module.exports = __webpack_public_path__ + "img/98ne.424fc5cc.svg";